import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "messageId", "zoneType"];
import React, { useEffect } from 'react';
import { defineUrlIcon } from '@carnica/graphics';
import { cnBem } from "../../../../shared/lib";
import { ymPushClickErrorIcon, ymPushMessageNotSent, ymPushViewErrorContextMenu, ymPushViewErrorSend } from "../../../../shared/analytics";
import { useAppDispatch, useAppSelector } from "../../../../shared/model";
import { selectContext, setContext } from "../../model";
import { setWindowBlocked } from "../../../settings/model";
import styles from "./styles.pcss";
var cnReloadIndicator = cnBem('reload-indicator', styles);
var IconDangerFilled = defineUrlIcon({
  ratio: 1,
  url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC41NCAxNS4yMDI1TDE1LjM3IDUuMTQyNUMxNC44MiA0LjA3MjUgMTMuODcgMy4zMjI1IDEyLjc2IDMuMDgyNUMxMi4yNiAyLjk3MjUgMTEuNzUgMi45NzI1IDExLjI1IDMuMDgyNUMxMC4xNCAzLjMyMjUgOS4xOCA0LjA3MjUgOC42MyA1LjE0MjVMMy40NiAxNS4yMDI1QzMuMTYgMTUuNzgyNSAzIDE2LjQzMjUgMyAxNy4wOTI1QzMgMTkuMjUyNSA0LjYyIDIxLjAwMjUgNi42MiAyMS4wMDI1SDE3LjM4QzE5LjM4IDIxLjAwMjUgMjEgMTkuMjUyNSAyMSAxNy4wOTI1QzIxIDE2LjQzMjUgMjAuODQgMTUuNzgyNSAyMC41NCAxNS4yMDI1Wk0xMi44OCAxNy4zMDI1QzEyLjg4IDE3Ljc4MjUgMTIuNDkgMTguMTgyNSAxMiAxOC4xODI1QzExLjUxIDE4LjE4MjUgMTEuMTIgMTcuNzkyNSAxMS4xMiAxNy4zMDI1VjE2LjgxMjVDMTEuMTIgMTYuMzMyNSAxMS41MSAxNS45MzI1IDEyIDE1LjkzMjVDMTIuNDkgMTUuOTMyNSAxMi44OCAxNi4zMjI1IDEyLjg4IDE2LjgxMjVWMTcuMzAyNVpNMTIuODggMTMuODkyNUMxMi44OCAxNC4zNzI1IDEyLjQ5IDE0Ljc3MjUgMTIgMTQuNzcyNUMxMS41MSAxNC43NzI1IDExLjEyIDE0LjM4MjUgMTEuMTIgMTMuODkyNVYxMC4wMDI1QzExLjEyIDkuNTIyNSAxMS41MSA5LjEyMjUgMTIgOS4xMjI1QzEyLjQ5IDkuMTIyNSAxMi44OCA5LjUyMjUgMTIuODggMTAuMDAyNVYxMy44OTI1WiIgZmlsbD0iIzI4MzAzRiIvPgo8L3N2Zz4K'
});
export var ReloadIndicator = function ReloadIndicator(props) {
  var className = props.className,
    messageId = props.messageId,
    zoneType = props.zoneType,
    otherProps = _objectWithoutProperties(props, _excluded);
  var context = useAppSelector(selectContext);
  var dispatch = useAppDispatch();
  useEffect(function () {
    ymPushMessageNotSent();
    ymPushViewErrorSend(zoneType);
  }, []);
  var handleClick = function handleClick() {
    dispatch(setContext({
      id: messageId,
      reason: 'error'
    }));
    dispatch(setWindowBlocked(true));
    ymPushClickErrorIcon(zoneType);
  };
  useEffect(function () {
    if ((context === null || context === void 0 ? void 0 : context.id) === messageId && (context === null || context === void 0 ? void 0 : context.reason) === 'error') {
      ymPushViewErrorContextMenu(zoneType);
    }
  }, [context]);
  return /*#__PURE__*/React.createElement(IconDangerFilled, _extends({
    "aria-label": "\u041C\u0435\u043D\u044E \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F",
    className: cnReloadIndicator(null, [className])
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ,
    color: "error",
    onClick: handleClick,
    tagName: "button",
    type: "button"
  }, otherProps, {
    "data-t-id": "ui-ReloadIndicator"
  }));
};